import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { LegalLinks } from '@/features/legal/legal-links';

/** Tela dividida: formulário à esquerda, foto da barbearia à direita (some no celular). */
export function AuthLayout({ title, subtitle, children, footer }: { title: string; subtitle?: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
      <div className="flex flex-col px-6 py-8 sm:px-12">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/favicon.svg" alt="" className="size-8" />
          <span className="font-display text-2xl font-extrabold">BarbeiroPro</span>
        </Link>
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-10">
          <h1 className="font-display text-4xl leading-none font-extrabold">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
          <LegalLinks newTab className="mt-6 text-muted-foreground" />
        </div>
      </div>
      <div className="relative hidden overflow-hidden bg-sidebar lg:block">
        <img src="/brand/auth.webp" alt="" className="absolute inset-0 size-full object-cover opacity-90" />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-10 text-white">
          <p className="max-w-md font-display text-3xl leading-tight font-bold">Agenda cheia, caixa fechado e cliente voltando.</p>
        </div>
      </div>
    </div>
  );
}
